<template>
    <span v-if="!fieldValid">{{
        $t('errors.MaxLength', { f: $t(fieldName), max: fieldMax })
    }}</span>
</template>
<script>
export default {
    components: {},

    props: {
        fieldName: { required: true },
        fieldValid: { required: true },
        fieldMax: { required: true },
    },
};
</script>
